import { useContext } from "react"
import { SnackBarContext } from "../contexts/SnackBarContext"
import { duration } from "@mui/material";
import { environment } from "../environments/environment";


export const useSnackBar = () => {
  const { snackbarState, setSnackbarState} = useContext(SnackBarContext);

  const openSnackBar = (msg, title, duration, severity) => {
    setSnackbarState({
      open: true,
      title,
      message: msg,
      type: severity,
      duration
    })
    // setSnackBarMessage(msg);
    // setSnackBarType(severity);
    // setSnackBarDuration(duration);
    // setSnackBarOpen(true);
  }

  const successMsg  = (title, msg="", duration=environment.snackbarsDisappearanceTime) => {
    openSnackBar(msg, title, duration, 'success');
  } 

  const infoMsg = (title, msg="", duration=environment.snackbarsDisappearanceTime) => {
    openSnackBar(msg, title, duration, 'info');
  }

  const warningMsg = (title, msg="", duration=environment.snackbarsDisappearanceTime) => {
    openSnackBar(msg, title, duration, 'warning');
  }
  const errorMsg = (title, msg="", duration=environment.snackbarsDisappearanceTime) => {
    openSnackBar(msg, title, duration, 'error');
  }

  return ({successMsg, infoMsg, warningMsg, errorMsg});

}